import { arrInc } from './fun-js-lib/arr'
import { htmlOnInput, htmlTagged } from './fun-js-lib/html'
import { isValidHour } from './validation/shiftTimes'
import { isValidNWorkers } from './validation/workers-and-mechanization'

export function initOverall () {
  htmlTagged(shiftTimeContainer(), 'input')
    .forEach(input => {
      htmlOnInput(input, setOverallTime)
    })

  htmlTagged(workerContainer(), 'input')
    .forEach(input => {
      htmlOnInput(input, setOverallWorkers)
    })

  setOverallTime()
  setOverallWorkers()
}

function setOverallTime () {
  let container = shiftTimeContainer()
  let starts = getInputValues(container, 'start')
  let ends = getInputValues(container, 'end')
  for (let i = 0; i < starts.length; ++i) {
    let start = starts[i]
    let end = ends[i]
    let text = ''
    if (isValidHour(start) && isValidHour(end)) {
      let overall = (+end - +start + 24) % 24
      text = '' + overall
    }
    setInputValue(container, 'time', i, text)
  }
}

function setOverallWorkers () {
  let container = workerContainer()
  let construction = getInputValues(container, 'constrw')
  let craft = getInputValues(container, 'craftw')
  let technical = getInputValues(container, 'technicalw')
  let other = getInputValues(container, 'otherw')
  for (let i = 0; i < construction.length; ++i) {
    let nConstruction = isValidNWorkers(construction[i]) ? +construction[i] : 0
    let nCraft = isValidNWorkers(craft[i]) ? +craft[i] : 0
    let nTechnical = isValidNWorkers(technical[i]) ? +technical[i] : 0
    let nOther = isValidNWorkers(other[i]) ? +other[i] : 0
    let overall = nConstruction + nCraft + nTechnical + nOther
    if (isValidNWorkers(construction[i])
      || isValidNWorkers(craft[i])
      || isValidNWorkers(technical[i])
      || isValidNWorkers(other[i])) {
      setInputValue(container, 'workers', i, '' + overall)
    } else {
      setInputValue(container, 'workers', i, '')
    }
  }
}

/**
 * @param {HTMLElement} container 
 * @param {string} className 
 */
function getInputValues (container, className) {
  let inputElements = container.getElementsByClassName(className)
  return arrInc(inputElements.length)
    .map(i => {
      /** @type {HTMLInputElement} */
      // @ts-ignore
      let element = inputElements[i]
      return element.value
    })
}

/**
 * @param {HTMLElement} container 
 * @param {string} className 
 * @param {number} index 
 * @param {string} value 
 */
function setInputValue (container, className, index, value) {
  /** @type {HTMLInputElement} */
  // @ts-ignore
  let inputElement = container.getElementsByClassName(className)[index]
  inputElement.value = value
}

function shiftTimeContainer () {
  return document.getElementById('shiftTimeContainer')
}

function workerContainer () {
  return document.getElementById('workerContainer')
}